import { ReactElement } from 'react';

import { IconPrefix } from '@fortawesome/fontawesome-common-types';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { validateIconType } from '@cloud-wave/neon-common-lib/app';

import Text from 'lib/common/components/Text';

import isDevEnvironment from 'lib/common/constants/isDevEnvironment';

type TNeonNowFaCollections = Extract<IconPrefix, 'fad' | 'far' | 'fab'>;
type TNeonNowFaCollectionsExtended = TNeonNowFaCollections | TNeonNowFaCollections[];

function getComponentName(child: ReactElement): string {
  const type = child.type;

  if (typeof type === 'string') {
    return type; // e.g., 'div'
  }

  if (typeof type === 'function' || typeof type === 'object') {
    return (type as any).displayName || (type as any).name || 'Anonymous';
  }

  return 'Unknown';
}

export default function WithEnforcedIconType({
  children,
  icon,
  expectedType,
}: {
  icon?: IconDefinition;
  children: ReactElement;
  expectedType: TNeonNowFaCollectionsExtended;
}) {
  if (!isDevEnvironment) {
    return children;
  }

  const expectedTypeInput = Array.isArray(expectedType) ? expectedType : [expectedType];

  try {
    validateIconType({ icon, expected: expectedTypeInput });
  } catch (e) {
    console.error(
      `A rendered element (${getComponentName(
        children
      )}) is using the wrong icon type. Expected ${expectedTypeInput.join(' or ')}).`,
      e
    );

    return <Text>This element is using the wrong icon type. Expected {expectedTypeInput.join(' or ')}.</Text>;
  }

  return children;
}
